import { lt } from '@mews/framework';
import { SelectField } from '@mews-commander/form';
import { ContentSection } from '@mews-commander/ui';
import { useAccountingCategoryOptions } from '../../queries/useAccountingCategoryOptions';

export const AllowanceAccountingStepFields = () => {
    const accountingCategoryOptions = useAccountingCategoryOptions();
    return (
        <ContentSection
            title={lt('AccountingCategoryPlural')}
            description={lt('AllowanceFormAccountingCategorySectionDescription')}
            spacing="300"
            contentSpacing="200"
        >
            <SelectField
                autoFocus
                helper={lt('AllowanceAccountingCategoryChargeDescription')}
                label={lt('AllowanceAccountingCategoryCharge')}
                name="chargeAccountingCategoryId"
                options={accountingCategoryOptions}
                required
            />
            <SelectField
                helper={lt('AllowanceAccountingCategoryConsumptionDescription')}
                label={lt('Consumption')}
                name="creditAccountingCategoryId"
                options={accountingCategoryOptions}
                required
            />
            <SelectField
                helper={lt('AllowanceAccountingCategoryProfitDescription')}
                label={lt('AllowanceAccountingCategoryProfit')}
                name="profitAccountingCategoryId"
                options={accountingCategoryOptions}
                required
            />
        </ContentSection>
    );
};
